import React from 'react';
import { Button } from '@ui';
import { REMOVE_KIND_UNLINK } from '../constants';
/**
 * The row action, which is NOT the same act for every row on this table.
 *
 * An uploaded attachment is destroyed, bytes and all. The three generated sources are join rows:
 * removing one detaches the document from this work order and leaves the Report or Proposal it
 * points at untouched, because that document is shared with other screens. Showing a trash icon
 * for both would promise a destruction that does not happen -- and, worse, read as though removing
 * an inspection report from a work order deletes the report.
 */
export function SupportDocumentActionCell({ item, onRequestRemove, deleteAriaLabel, unlinkAriaLabel }) {
    const isUnlink = item.removeKind === REMOVE_KIND_UNLINK;
    return (React.createElement(Button, { "aria-label": isUnlink ? unlinkAriaLabel(item.name) : deleteAriaLabel(item.name), onClick: (event) => {
            event.stopPropagation();
            onRequestRemove(item);
        } },
        React.createElement("i", { className: isUnlink ? 'fa-light fa-link-slash' : 'fa-light fa-trash', "aria-hidden": "true" })));
}
